module.exports = __webpack_public_path__ + "static/media/login-background2-en.746be1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background2-en.png
// module id = 1101
// module chunks = 114